import { Button } from '@driftt/tide-core'
import { Modal, ModalBody, ModalFooter, ModalTitle } from '@driftt/tide-modal'
import { pluralize } from 'humanize-plus'
import { isEmpty, path, pathOr } from 'ramda'
import React from 'react'
import { useSelector } from 'react-redux'
import scrollIntoView from 'scroll-into-view'

import { BlockUpdateVersionData } from 'api/blocks'
import { BLOCK_OUTDATED_MESSAGE, ValidationResult } from 'utils/validate'

import CollapsibleBlockChanges from '../CollapsibleBlockChanges'

import styles from './styles.module.css'

interface Props {
  isOpen: boolean
  onClose: () => void
  outdatedBlocks: BlockUpdateVersionData[]
}

const scrollToFirstBlockError = (playbookErrors: {
  [key: string]: ValidationResult
}) => {
  if (!isEmpty(playbookErrors)) {
    for (const nodeId in playbookErrors) {
      if (playbookErrors[nodeId].message === BLOCK_OUTDATED_MESSAGE) {
        const $target = document.querySelector(`#node-${nodeId} .inline-node`)
        return $target && scrollIntoView($target)
      }
    }
  }
}

const BlockUpdatesRequiredModal = ({
  outdatedBlocks,
  isOpen,
  onClose,
}: Props) => {
  const playbookValidation = useSelector(
    path(['__PLAYBOOK_EDITOR', 'playbookValidation'])
  )
  const playbookErrors = pathOr({}, ['playbook'], playbookValidation)
  return (
    <Modal open={isOpen} onClose={onClose} size="small">
      <ModalTitle>
        {outdatedBlocks.length} reusable block{' '}
        {pluralize(outdatedBlocks.length, 'update')} required
      </ModalTitle>
      <ModalBody>
        <>
          The structure of one or more of your reusable blocks has been changed.
          Please update your reusable blocks and review the updated conversation
          flow before publishing.
          <div className={styles.blockUpdatesRequiredModalSubheader}>
            Here's what changed:
          </div>
          {outdatedBlocks.map((outdatedBlock, index) => (
            <div
              key={index}
              className={styles.blockUpdatesRequiredModalBlockWrapper}
            >
              <div className={styles.blockUpdatesRequiredModalBlockName}>
                {outdatedBlock.name}
              </div>
              <CollapsibleBlockChanges blockChanges={outdatedBlock} />
            </div>
          ))}
        </>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onClose()
            scrollToFirstBlockError(playbookErrors)
          }}
        >
          Got it!
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default BlockUpdatesRequiredModal
